import { render } from "./PopoverTeleport.vue?vue&type=template&id=550ebd44&scoped=true"
import script from "./PopoverTeleport.vue?vue&type=script&lang=js"
export * from "./PopoverTeleport.vue?vue&type=script&lang=js"

import "./PopoverTeleport.vue?vue&type=style&index=0&id=550ebd44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550ebd44"]])

export default __exports__